import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SymptommsModel } from '../../models/careteam/careteam';
import { NgxSpinnerService } from 'ngx-spinner';
import { CareTEamService } from '../../services/care-team.service';
import { TranslateService } from '@ngx-translate/core';
import { CreateICDRequest, requestICD } from '../../models/symtomChecker/symptomsChecker';
import { SymptomsCheckerService } from 'src/app/services/symptoms-checker.service';
import { VerifypatientService } from '../../services/verifypatient.service';
import { AppointmentService } from '../../services/appointment.service';
import moment from 'moment';
declare var $: any;
@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css']
})
export class ThankYouComponent implements OnInit, OnDestroy {
  check_in_message: any = '';
  patientpersonalinfo: any;
  sympTomsModel!: SymptommsModel;
  alreadyCheckedin: boolean = false;
  isAndroid: boolean = false;
  isiOS: boolean = false;
  constructor(private _router: Router, private phrUtils: PhrutillsService, public sanitizer: DomSanitizer, private spinner: NgxSpinnerService, private careTeamService: CareTEamService,
    private router: Router, private translateService: TranslateService, private SymptomsCheckerService: SymptomsCheckerService, private _VerifypatientService: VerifypatientService, private appoint: AppointmentService,) {
    let info = localStorage.getItem('PersonalInfo');
    // console.log("info in thank you ", info);
    if (!info) {
      this._router.navigateByUrl("/");
      return;
    }


    if (localStorage.getItem("financialCheck")) {
      let havSetting = localStorage.getItem("financialCheck");
      if (havSetting) {
        let settings = JSON.parse(this.phrUtils.decrypt(havSetting));
        this.check_in_message = settings.data.checkIn_Message_Description;
        sessionStorage.setItem('check_in_message', this.check_in_message);
      }
      let info = localStorage.getItem('PersonalInfo');
      if (info) {
        // localStorage.clear();
      }
    }
    else {/*
      if (sessionStorage.getItem('check_in_message'))
        this.check_in_message = sessionStorage.getItem('check_in_message');
      else {
        console.log("no checkinmessage found ");
        this._router.navigateByUrl('/');
      }*/

    }
  }
  isothervisit: boolean;
  storedIsWithin24Hours: any;
  storedIsWithin3Hours: any;
  IsWithin3Hours: any;
  appointmentEndDate: any;
  appointmentEndTime: any;
  appointmentStartTime: any;
  appointmentStartDate: any;
  PatientAccount: any;
  PracticeCode: any;
  AppointmentID: any;
  patientFirstName: any;
  patientLastName: any;
  feedbackComment: any = '';
  appointmentAddress: any = '';
  appointmentCity: any = '';
  appointmentState: any = '';
  appointmentZip: any = '';
  currentLang: any = 'en';
  ngOnInit(): void {
    // Platform detection
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    this.isiOS = /iPad|iPhone|iPod/.test(userAgent);
    this.isAndroid = /android/i.test(userAgent);
    this.patientpersonalinfo = this.phrUtils.decrypt(localStorage.getItem('PersonalInfo'));
    //console.log("patient personal info ", this.patientpersonalinfo);
    const isAlredycheckin = localStorage.getItem("alredycheckin")
    if (isAlredycheckin == 'true') {
      this.alreadyCheckedin = true;
    } else {
      this.alreadyCheckedin = false;
    }

    const practicecode = localStorage.getItem('pcode');
    const apptid = localStorage.getItem('apptId');
    //console.log('appointment id', apptid);
    const ptaccount = localStorage.getItem('ptcode');
    const fname = localStorage.getItem('fname');
    const lname = localStorage.getItem('lname');
    // console.log(this.patientpersonalinfo)
    if (practicecode == null || practicecode == '' || practicecode == undefined) {
      this.PracticeCode = '';
    } else {
      this.PracticeCode = practicecode;
    }
    if (apptid == null || apptid == '' || apptid == undefined) {
      this.AppointmentID = '';
    } else {
      this.AppointmentID = apptid;
    }
    if (ptaccount == null || ptaccount == '' || ptaccount == undefined) {
      this.PatientAccount = '';
    } else {
      this.PatientAccount = ptaccount;
    }
    if (fname == null || fname == '' || fname == undefined) {
      this.patientFirstName = '';
    } else {
      this.patientFirstName = fname;
    }
    if (lname == null || lname == '' || lname == undefined) {
      this.patientLastName = '';
    } else {
      this.patientLastName = lname;
    }

    const apptAddr = localStorage.getItem('apptAddr');
    //console.log('appointment address', apptAddr);
    const apptst = localStorage.getItem('apptst');
    const apptcty = localStorage.getItem('apptcty');
    const aptzip = localStorage.getItem('aptzip');
    if (apptAddr == null || apptAddr == undefined) {
      this.appointmentAddress = '';
    } else {
      this.appointmentAddress = apptAddr;
    }
    if (apptst == null || apptst == undefined) {
      this.appointmentState = '';
    } else {
      this.appointmentState = apptst;
    }
    if (apptcty == null || apptcty == undefined) {
      this.appointmentCity = '';
    } else {
      this.appointmentCity = apptcty;
    }
    if (aptzip == null || aptzip == undefined) {
      this.appointmentZip = '';
    } else {
      this.appointmentZip = aptzip;
    }
    const ratingStatus = localStorage.getItem("Rate_" + this.patientpersonalinfo.APPOINTMENT_ID);
    console.log("rating status ", ratingStatus);
    if (ratingStatus != "Yes") {
      $('#rateVisit-model').modal('show');
    }
    /*
    setTimeout(() => {
      if ($('#rateVisit-model').hasClass('show') && this.rating == 0 && this.feedbackComment == '') {
        $('#rateVisit-model').modal('hide');
        localStorage.setItem("Rate_" + this.AppointmentID, "no");
      }
    }, 60000)*/

    const appointmentEnddateTime: any = localStorage.getItem('apptEndTime');
    const appointmentStartdateTime: any = localStorage.getItem('visitDate');
    //console.log("end date and time ", appointmentEnddateTime);
    //console.log("start date and time ", appointmentStartdateTime);
    // Split the string by the space to separate date and time
    if (appointmentEnddateTime == null || appointmentEnddateTime == '' || appointmentEnddateTime == undefined) {
      //console.log("inside ", appointmentEnddateTime);
    } else {
      //console.log("inside else end date", appointmentEnddateTime);
      const splitParts = appointmentEnddateTime.match(/(.+)\s(\d{1,2}:\d{2}:\d{2}\s?(AM|PM)?)/);

      if (splitParts && splitParts.length === 4) {
        this.appointmentEndDate = splitParts[1]; // Captures the date part
        this.appointmentEndTime = splitParts[2]; // Captures the time with AM/PM
      }
      //[this.appointmentEndDate, this.appointmentEndTime] = appointmentEnddateTime.split(' ');
    }

    if (appointmentStartdateTime == null || appointmentStartdateTime == '' || appointmentStartdateTime == undefined) {
      //console.log("inside ", appointmentStartdateTime);
    } else {
      //console.log("inside else start date", appointmentStartdateTime);
      this.appointmentStartDate = appointmentStartdateTime;
    }


    // Log the results
    //console.log('Date:', datePart);  // Output: 9/4/2024
    //console.log('Time:', timePart);  // Output: 9:00:00
    //this.appointmentEndDate = datePart;
    //this.appointmentEndTime = timePart;
    this.storedIsWithin24Hours = localStorage.getItem('isWithin24Hours');
    this.storedIsWithin3Hours = localStorage.getItem('isWithin3Hours');
    const reason = localStorage.getItem('reason');
    if (reason != 'Initial Visit') {
      this.isothervisit = true;
    }
    //console.log("is with in 3 hours " + this.storedIsWithin3Hours);
    if (this.isothervisit) {
      if (this.storedIsWithin3Hours == 'true') {
        this.IsWithin3Hours = true;
      } else {
        this.IsWithin3Hours = false;
      }
      //console.log("is within 3 hours " + this.IsWithin3Hours);
    }
    if (this.storedIsWithin24Hours == 'true') {
      this.IsWithin3Hours = true;
    }
    this.getAppointmentDetails();
    const ischeckin = localStorage.getItem("checkin")
    if (ischeckin != 'true') {
      //localStorage.setItem("updateAppointmentStatus", "false")
      // this.UpdateAppointmentstatus();

      const noIntakeFormValue = localStorage.getItem("noIntakeForm");
      //console.log(noIntakeFormValue);
      if (noIntakeFormValue && noIntakeFormValue === "true") {
        this.sympTomsModel = new SymptommsModel();
        this.sympTomsModel.visitReason = this.patientpersonalinfo.REASON_NAME.toLowerCase();
        this.sympTomsModel.feverOrChills = "false";
        this.sympTomsModel.cough = "false";
        this.sympTomsModel.shortnessOfBreathDifficultyBreathing = "false";
        this.sympTomsModel.fatigue = "false";
        this.sympTomsModel.muscleOrBodyAches = "false";
        this.sympTomsModel.headache = "false";
        this.sympTomsModel.newLossOfTasteOrSmell = "false";
        this.sympTomsModel.soreThroat = "false";
        this.sympTomsModel.congestionOrRunnyNose = "false";
        this.sympTomsModel.nauseaOrVomiting = "false";
        this.sympTomsModel.diarrhea = "false";
        this.sympTomsModel.diagnosedOrSuspected = "false";
        this.sympTomsModel.travelOutSideNjLastTwoWeak = "false";
        this.phrUtils.patientlanguage$.subscribe(language => {
          this.sympTomsModel.language = language;
        });
        this.onFinishIntake();

        //console.log(this.storedIsWithin24Hours);
        /*
        if ((this.patientpersonalinfo.PRACTICE_CODE == '1011163' || this.patientpersonalinfo.PRACTICE_CODE == '100') && this.patientpersonalinfo.REASON_NAME == 'Initial Visit') {
          if (this.storedIsWithin24Hours == 'true') {
            this.submitReason();
          }
        } else {
          this.isothervisit = true;
          if (this.patientpersonalinfo.PRACTICE_CODE != '447' && this.patientpersonalinfo.PRACTICE_CODE != '1010624' && this.patientpersonalinfo.PRACTICE_CODE !='1013142') {
            this.submitReason();
          }
        }*/
      }
    }

    this.phrUtils.patientlanguage$.subscribe(language => {
      //console.log("dafault " + language);
      if (language === 'es') {
        this.currentLang = language;
        this.phrUtils.setTitle('Gracias');
      } else if (language === 'hi') {
        this.currentLang = language;
        this.phrUtils.setTitle('धन्यवाद');
      }
      else if (language === 'ur') {
        this.currentLang = language;
        this.phrUtils.setTitle('شکریہ');
      }
      else {
        this.currentLang = 'en';
        this.phrUtils.setTitle('Thank You');
      }
    });
  }
  stars: number[] = [1, 2, 3, 4, 5]; // Represent 5 stars
  rating: any = 0; // Default rating (no stars selected)

  // Method to handle the star click event
  rate(star: number): void {
    this.rating = star; // Update the rating value
    console.log("rating ", this.rating)
  }
  phoneLink: any;
  appointment_details: any;
  appointmentDate: any;
  getAppointmentDetails() {
    this.spinner.show();
    this.appoint.getAppointmentDetails(this.patientpersonalinfo.PRACTICE_CODE, this.patientpersonalinfo.PATIENT_ACCOUNT, this.patientpersonalinfo.APPOINTMENT_ID).subscribe((res: any) => {
      this.spinner.hide();
      if (res.statusCode == 200) {
        this.spinner.hide();
        this.appointment_details = res.data;
        this.phoneLink = "tel:+1" + this.appointment_details.praC_PHONE;
        this.appointment_details.praC_PHONE = this.phrUtils.maskingPhoneNumer(this.appointment_details.praC_PHONE);
        this.appointmentAddress = this.appointment_details.appointment_Address;
        this.appointmentCity = this.appointment_details.appointment_City;
        this.appointmentState = this.appointment_details.appointment_State;
        this.appointmentZip = this.appointment_details.appointment_Zip;
        // Original date string
        const appointmentDateTimeString = this.appointment_details.appointment_Date_Time;
        const appointmentDateTime = new Date(appointmentDateTimeString);
        this.appointmentDate = appointmentDateTime.toLocaleDateString();
        this.appointment_details.praC_ZIP = this.appointment_details.praC_ZIP.length > 5 ? this.phrUtils.maskingZipNum(this.appointment_details.praC_ZIP) : this.appointment_details.praC_ZIP;

      }
    }, (error: any) => {
      this.spinner.hide();
    })
  }

  get isSpanishLang(): boolean {
    let lang = localStorage.getItem('language');
    return lang === 'es';
  }
  get isHindiLang(): boolean {
    let lang = localStorage.getItem('language');
    return lang === 'hi';
  }
  get isEnglishLang(): boolean {
    let lang = localStorage.getItem('language');
    return lang === 'en';
  }
  AppointmentStatusConfirmed: any;
  UpdateAppointmentstatus() {
    //tM2hXGTAFn9xY21Pd7JGYg==
    // this.appointmentid;
    this.spinner.show();
    const apptid = localStorage.getItem("apptId");
    this.AppointmentStatusConfirmed = 2;
    this._VerifypatientService.ConfirmAppointment(apptid, this.AppointmentStatusConfirmed).subscribe((res: any) => {

      if (res.message == "Record Updated") {
        localStorage.setItem("updateAppointmentStatus", "true")
      } else {
        localStorage.setItem("updateAppointmentStatus", "false")
      }


    })
  }

  rateObj: any = {};
  RateYourVisit() {
    if (this.rating == 0 && this.feedbackComment == '') {
      $('#rateVisit-model').modal('hide');
      localStorage.setItem("Rate_" + this.patientpersonalinfo.APPOINTMENT_ID, "No");
      console.log("no rating");
      return;
    }
    this.rateObj['practiceCode'] = this.patientpersonalinfo.PRACTICE_CODE;
    this.rateObj['patientAccount'] = this.patientpersonalinfo.PATIENT_ACCOUNT;
    this.rateObj['appointmentID'] = this.patientpersonalinfo.APPOINTMENT_ID;
    this.rateObj['rating'] = this.rating;
    this.rateObj['comments'] = this.feedbackComment;
    this.rateObj['appSource'] = 'breezeCheckin';
    this.careTeamService.RateYourVisit(this.rateObj).subscribe((res: any) => {
      if (res && res.statusCode == 200 && res.message == "Visit rating inserted successfully") {
        localStorage.setItem("Rate_" + this.patientpersonalinfo.APPOINTMENT_ID, "Yes");
      } else {
        localStorage.setItem("Rate_" + this.patientpersonalinfo.APPOINTMENT_ID, "No");
      }
    }, (error: any) => {
      localStorage.setItem("Rate_" + this.patientpersonalinfo.APPOINTMENT_ID, "No");
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      //this.phrUtils.showError(text);
      //this.phrUtils.showError("Service is not available, please try later.");
    });
  }

  onFinishIntake() {
    this.sympTomsModel.first_name = this.patientpersonalinfo.FIRSTNAME;
    this.sympTomsModel.last_name = this.patientpersonalinfo.LASTNAME;
    this.sympTomsModel.patient_account = "" + this.patientpersonalinfo.PATIENT_ACCOUNT;
    this.sympTomsModel.practiceCode = this.patientpersonalinfo.PRACTICE_CODE;
    this.sympTomsModel.appointment_id = "" + this.patientpersonalinfo.APPOINTMENT_ID;
    // console.log("last call payload",this.sympTomsModel);
    // return;
    this.careTeamService.covidQuestionnire(this.sympTomsModel).subscribe((res: any) => {
      this.spinner.hide();
      if (res && res.statusCode == 200 && res.message == "SUCCESS") {
        console.log("covid call completed");
        if (res.data.status == "link expired") {
          let text = "Link expired.";
          this.translateService.get('Alerts.family_history_linked_expired').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          // this.phrUtils.showError("Link expired.");
          this.router.navigateByUrl('/');
        }
        else if (res.data.status == "Success") {
          //this.phrUtils.showSuccess("Saved successfully");
          //this.router.navigateByUrl('patient/thank-you');
        }
        else if (res.data.status == "Fail to insert symtoms") {
          let text = "Failed to insert symtoms.";
          this.translateService.get('Alerts.failed_to_insert_symtoms').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          //this.phrUtils.showError("Failed to insert symtoms.");
        }
        else if (res.data.status == "Fail to update appointment") {
          let text = "Failed to update appointment.";
          this.translateService.get('Alerts.failed_to_update_appointment').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          //this.phrUtils.showError("Failed to update appointment.");
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          // this.phrUtils.showError("Service is not available, please try later.");
        }
      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
      //this.phrUtils.showError("Service is not available, please try later.");
    });
  }


  CreateICDRequest: any;
  submitReason() {
    const reason = localStorage.getItem("visitReason")
    //console.log(reason);
    if (reason) {
      var reasonValue = this.phrUtils.decrypt(reason)
    }
    let request: any = new requestICD();
    const visitdate = localStorage.getItem('visitDate')
    if (visitdate) {
      request.DOS = visitdate;
    } else {
      //request.DOS = this.InitialQuestionResponce.result.DOS;
      request.DOS = '';
    }
    request.ICDS = "";
    request.SUMMARY = reasonValue;
    request.DOB = this.patientpersonalinfo.DOB;
    request.PROVIDER_CODE = this.patientpersonalinfo.PROVIDER_CODE;
    request.PRACTICE_CODE = this.patientpersonalinfo.PRACTICE_CODE;
    request.TRANSACTION_ID = 0;
    request.PATIENT_ACCOUNT = this.patientpersonalinfo.PATIENT_ACCOUNT;
    request.CREATED_DATE = visitdate;
    request.MODIFIED_DATE = visitdate;
    //request.ROS_CAT_WITH_SYM = [];
    request.DELETED = 0;
    request.R_CODES = "";
    request.DIP_HTML = '',
      request.RISK_HTML = '';
    request.SYM_TO_ROS = '';
    //request.encounter_id = 0;
    this.CreateICDRequest = new CreateICDRequest();
    this.CreateICDRequest.request.push(request);


    let lang = localStorage.getItem('language');
    if (!lang)
      lang = 'en';

    this.SymptomsCheckerService.IcdPredictionSaveData(this.CreateICDRequest, lang).subscribe((res: any) => {
      this.spinner.hide();
      // console.log(res);
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
      //this.phrUtils.showError("Service is not available, please try later.");
    });


  }
  ngOnDestroy() {
    localStorage.clear();
  }

  //add to calendar
  addToCalendar() {
    // Define the event details
    const title = this.appointment_details.reasonName + ' Appointment'; //reason + appointment
    const description = this.appointment_details.reasonName + ' Appointment with ' + this.appointment_details?.provid_FName + ' ' + this.appointment_details?.provid_LName; //reason + appointment + with + provider name
    const location = this.appointmentAddress + ', ' + this.appointmentCity + ', ' + this.appointmentState + ' ' + this.appointmentZip; //location
    const appointmentdate = this.appointmentDate;
    const appointTime = this.appointment_details.time_From;

    console.log("start date ", appointmentdate);
    console.log("start time ", appointTime);
    console.log("end date ", this.appointmentEndDate);
    console.log("end time ", this.appointmentEndTime);
    /// const startDate = new Date(`${appointmentdate} ${appointTime}`); // Use your event start date and time
    const appontDateTimeStr = `${this.appointmentStartDate} ${appointTime}`;

    const startDate = this.ConverttoLocalDate(appontDateTimeStr); // Use your event start date and time
    console.log("start date ", startDate);
    // const startDate = new Date('2024-09-04T09:00:00'); // Use your event start date and time

    const appontEndDateTimeStr = `${this.appointmentEndDate} ${this.appointmentEndTime}`;
    const endDate = this.ConverttoLocalDate(appontEndDateTimeStr);
    console.log("end date ", endDate);
    //const endDate = new Date(`${this.appointmentEndDate} ${this.appointmentEndTime}`)
    // const endDate = new Date('2024-09-04T10:00:00'); // Use your event end date and time

    // Convert dates to the proper format (YYYYMMDDTHHMMSSZ)
    const start = startDate.toISOString().replace(/-|:|\.\d+/g, '');
    const end = endDate.toISOString().replace(/-|:|\.\d+/g, '');

    // Create the .ics file content
    const icsContent = `
BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Your Organization//Your Product//EN
BEGIN:VEVENT
UID:${new Date().getTime()}@yourdomain.com
DTSTAMP:${new Date().toISOString().replace(/-|:|\.\d+/g, '')}
DTSTART:${start}
DTEND:${end}
SUMMARY:${title}
DESCRIPTION:${description}
LOCATION:${location}
END:VEVENT
END:VCALENDAR
    `.trim();

    // Create a Blob from the .ics content and download it
    const blob = new Blob([icsContent], { type: 'text/calendar' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'event.ics';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  //ConverttoLocalDate(date: any): Date {
  //  // if (!date) return '';

  //  // if (date instanceof Date) {
  //  date = this.hasTimezone(date) ? this.removeZ(date) : date;

  //  date = moment(date).format('MM/DD/Y h:mm:ss');
  //  //date = moment(date).format('MM/DD/YYYY');
  //  date = new Date(date);

  //  // }

  //  return date;
  //}


  ConverttoLocalDate(date: any): Date {
    // If the input date has a timezone, remove the "Z" character
    date = this.hasTimezone(date) ? this.removeZ(date) : date;

    // Use moment to correctly parse the date and retain AM/PM formatting if provided
    const formattedDate = moment(date, ['MM/DD/YYYY h:mm A', 'MM/DD/Y h:mm:ss A']).toDate();

    return formattedDate;
  }


  private hasTimezone(value: any) {
    if (typeof value !== 'string') return false;
    return (value.includes('T') || value.includes('t'));
  }

  private removeZ(value: any) {
    if (!value) return '';
    return value.replace(/z|Z/, '');
  }


  ngAfterViewInit() {
    const backdrop = document.querySelector('.modal-backdrop');
    console.log("backdrop ", backdrop);
    if (backdrop) {
      // backdrop.remove();
    }
  }

}
